import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  private statusSub?: Subscription;
  private initializedSub?: Subscription;
  private consentSubject = new BehaviorSubject<boolean>(false);
  consent$ = this.consentSubject.asObservable();

  constructor(private ccService: NgcCookieConsentService) { }
  private promptRetries = 0;
  private readonly maxPromptRetries = 20;

  init(): void {
    console.log('[CookieConsent] init called');
    this.statusSub = this.ccService.statusChange$.subscribe((event) => {
      console.log('[CookieConsent] statusChange$', event.status);
      this.consentSubject.next(event.status === 'allow' || event.status === 'dismiss');
    });

    this.initializedSub = this.ccService.initialized$.subscribe(() => {
      console.log('[CookieConsent] initialized$ fired');
      this.consentSubject.next(this.ccService.hasConsented());
    });
  }

  hasConsented(): boolean {
    return this.consentSubject.value;
  }

  openBanner(): void {
    this.ccService.open();
  }

  promptIfNeeded(): void {
    console.log('[CookieConsent] promptIfNeeded called');
    this.promptRetries = 0;
    this.tryPromptWithRetry();
  }

  private tryPromptWithRetry(): void {
    try {
      const hasAnswered = this.ccService.hasAnswered();
      console.log('[CookieConsent] hasAnswered =', hasAnswered);
      if (!hasAnswered) {
        console.log('[CookieConsent] opening banner');
        this.ccService.open();
      }
    } catch (error) {
      this.promptRetries += 1;
      console.log('[CookieConsent] popup not ready, retry', this.promptRetries, error);
      if (this.promptRetries < this.maxPromptRetries) {
        setTimeout(() => this.tryPromptWithRetry(), 150);
      } else {
        console.log('[CookieConsent] giving up after retries');
      }
    }
  }

  destroy(): void {
    this.statusSub?.unsubscribe();
    this.initializedSub?.unsubscribe();
  }
}
